import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import NotFound from '../pages/NotFound';

const NavigationRoutes: React.FunctionComponent = () => {
  return (
    <>
      {!window.location.href.includes('/vs/') ? (
        <AuthenticatedRoutes />
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
};

export default NavigationRoutes;
